export default "__VITE_ASSET__BlkRIXun__"